<template>
  <div class="dashboard">
      <div class = "main-container">
        <div class = "forhove dashboard-div" :class="{ activeMethod: selectedItem === 'dashboard'}" @click="selectedMethod('dashboard')">
          <v-icon class="icon-color material-icons-round" >
            dashboard
          </v-icon>
          <p class = "dashboard-title">
            Dashboard
          </p>
        </div>
        <div class = "growth-div" @click = "displayGrowth = !displayGrowth">
          <v-icon v-show = "displayGrowth" class="material-icons-round">
            arrow_drop_down
          </v-icon>
          <v-icon v-show = "!displayGrowth" class="material-icons-round">
            arrow_drop_up
          </v-icon>
          <img src = '/img/growth-icon-normal.svg' id = "growthImage">
          <p class = "growth-title" v-bind:style="{ color: growthColor }">
            Growth Plan
          </p>
        </div>
        <div class = "dropdown-plan" v-show = "displayGrowth">
            <div class = "planContainer forhove" :class="{ activeMethod: selectedItem === 'growthAggressive'}" @click="selectedMethod('growthAggressive')">
                <p class = "plan-text">Aggressive</p>
                <img v-if = "growthAggAmount > 0" src = '/img/Active-Plan.svg'>
            </div>
            <div class = "planContainer forhove" :class="{ activeMethod: selectedItem === 'growthConservative'}" @click="selectedMethod('growthConservative')">
                <p class = "plan-text">Conservative</p>
                <img v-if = "growthConsAmount > 0" src = '/img/Active-Plan.svg'>
            </div>
          </div>
        <div class = "growth-div" @click = "displayIncome = !displayIncome">
          <v-icon v-show = "displayIncome" class="material-icons-round">
            arrow_drop_down
          </v-icon>
          <v-icon v-show = "!displayIncome" class="material-icons-round">
            arrow_drop_up
          </v-icon>
          <v-icon class="material-icons-round" v-bind:style="{ color: incomeColor }">
            calendar_month
          </v-icon>
          <p class = "growth-title" v-bind:style="{ color: incomeColor }">
            Income Plan
          </p>
        </div>
        <div class = "dropdown-plan" v-show = "displayIncome">
            <div class = "planContainer forhove" :class="{ activeMethod: selectedItem === 'incomeAggressive'}" @click="selectedMethod('incomeAggressive')">
                <p class = "plan-text forhove">Aggressive</p>
                <img v-if = "incomeAggAmount > 0" src = '/img/Active-Plan.svg'>
            </div>
            <div class = "planContainer forhove" :class="{ activeMethod: selectedItem === 'incomeConservative'}" @click="selectedMethod('incomeConservative')">
                <p class = "plan-text forhove">Conservative</p>
                <img v-if = "incomeConsAmount > 0" src = '/img/Active-Plan.svg'>
            </div>
        </div>
      </div>
      <nav class="nav">
        <div class="nav__link" :class="{ activeMethodMobile: selectedItem === 'dashboard'}" @click="selectedMethodMobile('dashboard')">
          <v-icon class="mobileIcons material-icons-round" >
            dashboard
          </v-icon>
          <span class="mobile_text">Dashboard</span>
        </div>
        <div class="nav__link" :class="{ activeMethodMobile: selectedItem === 'growth' || selectedItem === 'growthAggressive' || selectedItem === 'growthConservative'}" @click="selectedMethodMobile('growth')">
          <img src = '/img/growthIconGrey.svg' class="mobileIcons" id = "growthImageMobile">
          <span class="mobile_text">Growth</span>
        </div>
        <div class="nav__link" :class="{ activeMethodMobile: selectedItem === 'income' || selectedItem === 'incomeAggressive' || selectedItem === 'incomeConservative'}" @click="selectedMethodMobile('income')">
          <v-icon class="mobileIcons material-icons-round">
            calendar_month
          </v-icon>
          <span class="mobile_text">Income</span>
        </div>
      </nav>
      <div class = "content">
        <component
            v-bind:is="currentTabComponent"
            :selectedItem="selectedItem"
        ></component>
      </div>
      <div>
        <!-- <escrowInvestDialog
            v-if="showEscrowInvestDialog"
            :showEscrowInvestDialog="showEscrowInvestDialog"
            :escrowBalance = "escrowBalance"
            :incomeAmount = "incomeAmount"
            @closeDialog="closeEscrowDialog"
        /> -->
        <escrowWalletDialog
            v-if="showEscrowWalletDialog"
            :showEscrowWalletDialog="showEscrowWalletDialog"
            :escrowBalance = "escrowBalance"
            :incomeAmount = "incomeAmount"
            @closeDialog="closeEscrowWalletDialog"
        />
    </div>
    <div v-if = "accountStatus !== 'FROZEN' " class="float" @click="selectPlan">
        <div class = "floatingContainer">
            <i class="fa fa-plus float_icon">
                <span class = "investText" v-if = "showInvest">Invest</span>
            </i>
        </div>
    </div>
  </div>
</template>

<script>
import mainDashboard from '@/components/dashboard/dashboardSummary.vue'
import growthPortfolio from '@/components/dashboard/growthPortfolio.vue'
import incomePortfolio from '@/components/dashboard/incomePortfolio.vue'
// import escrowInvestDialog from '@/components/common/escrowInvestDialog.vue'
import escrowWalletDialog from '@/components/common/escrowWalletDialog.vue'

export default {
    name: 'Dashboard',
    components: {
        mainDashboard,
        growthPortfolio,
        incomePortfolio,
        escrowWalletDialog
        // escrowInvestDialog
    },
    data () {
        return {
            notifications: [],
            name: null,
            selectedItem: '',
            displayGrowth: true,
            displayIncome: true,
            growthColor: '#232323',
            incomeColor: '#232323',
            currentTabComponent: '',
            showEscrowInvestDialog: false,
            showEscrowWalletDialog: false,
            escrowBalance: null,
            incomeAmount: null,
            windowsTop: 0,
            showInvest: true,
            growthAggAmount: 0,
            growthConsAmount: 0,
            incomeConsAmount: 0,
            incomeAggAmount: 0,
            accountStatus: null
        }
    },
    mounted () {
        this.accountStatus = this.$store.getters['dashboard/getAccountStatus']
        this.addPortfolioAmount()
        this.selectedItem = this.$store.getters['dashboard/getSelectedItem']
        if (this.selectedItem === 'growth' || this.selectedItem === 'income') {
            this.selectedMethodMobile(this.selectedItem)
        } else {
            this.selectedMethod(this.selectedItem)
        }
        const chartDetails = this.$store.getters['dashboard/getChartDetails']
        this.escrowBalance = chartDetails.escrowBalance
        this.incomeAmount = chartDetails.incomeAmount
        if (this.escrowBalance > 0 || this.incomeAmount > 0) {
            this.showEscrowWalletDialog = true
        }
    },
    methods: {
        closeEscrowWalletDialog () {
            this.showEscrowWalletDialog = false
        },
        addPortfolioAmount () {
            const cart = this.$store.getters['dashboard/getAllPortfolios']
            for (var i = 0; i < cart.length; i++) {
                if (cart[i].planType === 'income' && cart[i].riskProfile === 'conservative') {
                    if (cart[i]?.investmentValue) {
                        this.incomeConsAmount = Math.round(cart[i].investmentValue / 100)
                    }

                    if (cart[i]?.pendingInvestmentAmount) {
                        this.incomeConsAmount += Math.round(cart[i].pendingInvestmentAmount / 100)
                    }
                } else if (cart[i].planType === 'income' && cart[i].riskProfile === 'aggressive') {
                    if (cart[i]?.investmentValue) {
                        this.incomeAggAmount = Math.round(cart[i].investmentValue / 100)
                    }

                    if (cart[i]?.pendingInvestmentAmount) {
                        this.incomeAggAmount += Math.round(cart[i].pendingInvestmentAmount / 100)
                    }
                } else if (cart[i].planType === 'growth' && cart[i].riskProfile === 'aggressive') {
                    if (cart[i]?.investmentValue) {
                        this.growthAggAmount = Math.round(cart[i].investmentValue / 100)
                    }

                    if (cart[i]?.pendingInvestmentAmount) {
                        this.growthAggAmount += Math.round(cart[i].pendingInvestmentAmount / 100)
                    }
                } else if (cart[i].planType === 'growth' && cart[i].riskProfile === 'conservative') {
                    if (cart[i]?.investmentValue) {
                        this.growthConsAmount = Math.round(cart[i].investmentValue / 100)
                    }

                    if (cart[i]?.pendingInvestmentAmount) {
                        this.growthConsAmount += Math.round(cart[i].pendingInvestmentAmount / 100)
                    }
                }
            }
        },
        selectPlan () {
            this.$router.push({ path: '/select-plan' })
        },
        selectedMethod (option) {
            this.selectedItem = option
            this.$store.commit('dashboard/setField', {
                field: 'selectedItem',
                value: this.selectedItem
            })
            if (this.selectedItem === 'growthAggressive' || this.selectedItem === 'growthConservative') {
                this.currentTabComponent = 'growthPortfolio'
                this.growthColor = '#002fa7'
                this.incomeColor = '#232323'
                document.getElementById('growthImage').src = '/img/growth-icon-selected.svg'
            } else if (this.selectedItem === 'incomeAggressive' || this.selectedItem === 'incomeConservative') {
                this.currentTabComponent = 'incomePortfolio'
                this.incomeColor = '#002fa7'
                this.growthColor = '#232323'
                document.getElementById('growthImage').src = '/img/growth-icon-normal.svg'
            } else {
                this.currentTabComponent = 'mainDashboard'
                this.incomeColor = '#232323'
                this.growthColor = '#232323'
                document.getElementById('growthImage').src = '/img/growth-icon-normal.svg'
            }
        },
        selectedMethodMobile (option) {
            this.selectedItem = option
            this.$store.commit('dashboard/setField', {
                field: 'selectedItem',
                value: this.selectedItem
            })
            if (this.selectedItem === 'growth') {
                document.getElementById('growthImageMobile').src = '/img/growthIconBlue.svg'
                if (this.growthAggAmount > this.growthConsAmount) {
                    this.selectedItem = 'growthAggressive'
                } else if (this.growthAggAmount < this.growthConsAmount) {
                    this.selectedItem = 'growthConservative'
                } else {
                    this.selectedItem = 'growthAggressive'
                }
                this.currentTabComponent = 'growthPortfolio'
            } else if (this.selectedItem === 'income') {
                document.getElementById('growthImageMobile').src = '/img/growthIconGrey.svg'
                if (this.incomeAggAmount > this.incomeConsAmount) {
                    this.selectedItem = 'incomeAggressive'
                } else if (this.incomeAggAmount < this.incomeConsAmount) {
                    this.selectedItem = 'incomeConservative'
                } else {
                    this.selectedItem = 'incomeAggressive'
                }
                this.currentTabComponent = 'incomePortfolio'
            } else {
                this.currentTabComponent = 'mainDashboard'
                document.getElementById('growthImageMobile').src = '/img/growthIconGrey.svg'
            }
        },
        closeEscrowDialog () {
            this.showEscrowInvestDialog = false
            const chartDetails = this.$store.getters['dashboard/getChartDetails']
            this.escrowBalance = chartDetails.escrowBalance
        }
    }
}
</script>
<style lang="scss" scoped>
@import "~@/sass/components/_dashboard-layout.scss";

.planContainer {
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: 50px;
    margin-bottom: 10px;
    padding: 10px;
    border-radius: 8px;
}
.investText {
    font-family: 'Inter', sans-serif;
    padding-left: 8px;
    font-weight: 600;
    color: #ffffff !important
}
.floatingContainer {
    display: flex;
    flex-direction: column;
}
.float{
    z-index: 2;
    position: fixed;
    width: 120px;
    height: 44px;
    bottom: 25px;
    right: 35px;
    background-color: #002fa7;
    color: #ffffff;
    border-radius: 50px;
    text-align: center;
    cursor: pointer;
    opacity: 1;
    transition: 0.5s ease;
}

.float_icon{
    margin-top: 15px;
    color: #ffffff !important
}
.mobileIcons {
    height: 18px;
    width: 18px;
    color: #8c8c8c !important
}
.mobile_text {
    color: #8c8c8c;
    font-size: 10px
}
.notifications {
    position: relative;
}
.mobileTabs {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

.icon {
  position: absolute;
  top: 12px;
  right: 12px;
  cursor: pointer;
}

.dashboard {
  padding-top: 20px !important;
  display: flex;
  flex-direction: row;
  align-content: center;
}

.dashboard-div {
  width: 240px;
  display: flex;
  flex-direction: row;
  padding: 16px;
  border-radius: 8px;
  align-items: center;
  cursor: pointer  !important;
}

.main-container {
  width: max-content;
  display: flex;
  flex-direction: column;
}

.dashboard-title {
  padding-left: 8px;
  margin-bottom: 0px !important;
  width: 240px;
  margin-left : 10px;
  font-weight: 500;
  font-size: 18px;
  color: #232323;
  text-decoration: none;
}
.growth-title {
  margin-bottom: 0px !important;
  width: 240px;
  margin-left : 10px;
  font-weight: 500;
  font-size: 18px;
  color: #232323;
  text-decoration: none;
}

.growth-div {
  margin-top: 10px;
  width: 220px;
  display: flex;
  flex-direction: row;
  padding: 18px;
  padding-left: 0px !important;
  border-radius: 8px;
  align-items: center;
  cursor: pointer  !important;
}

.plan-text {
  color: #6a6a6a;
  font-weight: 500;
  font-size: 15px;
  margin-bottom: 0px;
  width: 100%;
  text-align: left;
}
.mobileTabs {
  display: none;
}
.body {
    margin: 0 0 55px 0;
}

.nav {
    display: none;
}

.nav__link {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex-grow: 1;
    min-width: 50px;
    overflow: hidden;
    white-space: nowrap;
    font-family: sans-serif;
    font-size: 13px;
    color: #444444;
    text-decoration: none;
    -webkit-tap-highlight-color: transparent;
    transition: background-color 0.1s ease-in-out;
}

.nav__icon {
    font-size: 18px;
}

.forhove {
  &:hover {
    background-color: #f2f6ff!important;
    color: #000000 !important;
    .dashboard-title {
      color: #000000 !important;
    }
    .v-icon.v-icon {
      color: #000000 !important;
    }
    .plan-text {
        color: #000000 !important;
    }
  }
}

.v-icon.v-icon {
  color: #000000
}

.activeMethod {
    background-color: #002Fa7!important;
    color: $white !important;

    .plan-text {
        color: $white !important;
    }
  .dashboard-title {
    color: $white !important;
  }
  .v-icon.v-icon {
      color: $white !important;
  }
}
.activeMethodMobile {
  .mobileIcons {
    color: #002fa7 !important
  }
  .mobile_text {
    color: #002fa7 !important
  }
}
.content {
  width: 100%;
  padding-bottom: 55px;
}

@media(max-width: 1000px) {
  .dashboard {
    display: flex;
    flex-direction: column;
    align-content: center;
  }

  .main-container {
    display: none;
  }
  .mobileTabs {
    display: initial;
  }
  .nav {
      position: fixed;
      z-index:200;
      bottom: 0;
      right: 0px;
      width: 100%;
      height: 55px;
      box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
      background-color: #ffffff;
      display: flex;
      overflow-x: auto;
  }
  .float{
        bottom:65px !important;
    }
}
</style>
